import { CatalogProductInterface } from '@/libs/cpq-builder/product.interface';
import { CatalogCpqJson }          from '@/libs/cpq-builder/cpq-json.interface';
import { InjectionKey }            from 'vue';
import { Store, useStore }         from 'vuex';

export interface StateInterface {
  // SaleSqueze
  catalog: {
    products: CatalogProductInterface[]
  },
  cpq: CatalogCpqJson,

  // App
  automatedGuideFlow: boolean;
  previewImageUrl: string;
  linijaList: {
    value: string,
    title: string,
    thumbnail: string
  };
  oblikaList: {
    value: string,
    title: string,
    thumbnail: string
  }
  responseTiles: any;
  selectedTiles: any;
  responseCurbs: any;
  curbs: any;
  responseScarpElements: any;
  scarpElements: any;
  groutSlider: boolean;
  responseGrouts: any;
  grouts: any;
  impregnationSlider: boolean;
  responseImpregnation: any;
  impregnation: any;
  responseAddons: any;
  addons: any;
  contact: {
    firstName: string,
    lastName: string,
    email: string,
    phone: string,
    address: string,
    city: string,
    postalCode: string,
    deliveryType: string,
    deliveryAddress: string,
    deliveryCity: string,
    deliveryPostalCode: string,
    sameDeliveryAddress: boolean,
    note: string
  };
  salonList: {
    title: string,
    naslov: string,
    mesto: string,
    postnaStevilka: string,
    email: string,
    podjetje: string,
    podjetjeNaslov: string,
    podjetjePostnaStevilka: string
  };
  salon: any;
  screenshot: string;
  takeScreenshot: boolean;
  errors: any;
  activeErrors: any;
  counter: number;
  products: any;
  meshCreated: number;
}

// define store injection key
export const key: InjectionKey<Store<StateInterface>> = Symbol()

export function useDefaultStore () {
  return useStore(key)
}
